import { useState, useEffect } from 'react';
import './alet_notification_display.css'; 

const ApiPollingAlert = ({ apiUrl, pollingInterval }) => { 
  const [toasts, setToasts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isWithinTradingHours, setIsWithinTradingHours] = useState(false);


  const checkTradingHours = () => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    
    // Convert to minutes for easier comparison
    const currentTimeInMinutes = hours * 60 + minutes;
    const startTimeInMinutes = 9 * 60 + 7;    // 9:07 AM
    const endTimeInMinutes = 15 * 60 + 30;    // 3:30 PM
    
    return currentTimeInMinutes >= startTimeInMinutes && currentTimeInMinutes <= endTimeInMinutes;
  };


  const removeToast = (id) => {
    setToasts(currentToasts => currentToasts.filter(toast => toast.id !== id));
  };


  const fetchData = async () => {  
    if (!checkTradingHours()) {
      setIsWithinTradingHours(false);
      return;
    }
    
    setIsWithinTradingHours(true);
    
    try {
      const response = await fetch(apiUrl);
      const newData = await response.json();
      
      // Clear previous toasts and only show current API data
      const currentToasts = [];
      
      if (newData && Array.isArray(newData) && newData.length > 0) {
        // Create toast notifications from the current data
        newData.forEach(item => {
          if (item.ticker_code && item.crossed_price && item.tick_num_done && item.condition_is) {
            const conditionText = item.condition_is === '>=' ? 'GT ' : 'LT ';
            const toastType = conditionText.trim() === 'LT' ? 'error' : 'success';
            
            currentToasts.push({
              id: `${item.ticker_code}-${item.crossed_price}-${item.tick_num_done}`,
              message: `${item.ticker_code} is ${conditionText} target price of ${item.crossed_price} at ${item.tick_num_done}`,
              type: toastType
            });
          }
        });
      }
      
      // Replace all toasts with current data
      setToasts(currentToasts);
      setLoading(false);
      
      // Auto-remove toasts after 12 seconds (3 seconds before next poll)
      // This ensures notifications disappear shortly before new ones might appear
      if (currentToasts.length > 0) {
        const timeoutId = setTimeout(() => {
          setToasts([]);  // Clear all toasts at once
        }, 12000);
        
        // Return cleanup function to prevent memory leaks
        return () => clearTimeout(timeoutId);
      }
      
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  // Set up polling effect
  useEffect(() => {
    // Check trading hours initially
    const initialCheck = checkTradingHours();
    setIsWithinTradingHours(initialCheck);
    
    // Only fetch data if within trading hours
    if (initialCheck) {
      fetchData();
    }
    
    // Set up polling interval
    const pollingId = setInterval(() => {
      if (checkTradingHours()) {
        fetchData();
      } else {
        setIsWithinTradingHours(false);
        setToasts([]); // Clear any existing toasts when outside trading hours
      }
    }, pollingInterval);
    
    // Additionally, check trading hours every minute to start/stop polling at boundaries
    const hourCheckerId = setInterval(() => {
      setIsWithinTradingHours(checkTradingHours());
    }, 60000); // Check every minute
    
    // Clean up intervals on unmount
    return () => {
      clearInterval(pollingId);
      clearInterval(hourCheckerId);
    };
  }, [apiUrl, pollingInterval]);

  // Only render the toast container if we have toasts to show
  return (
    <div className="api-polling-container">
      {toasts.length > 0 && (
        <div className="toast-container">
          {toasts.map(toast => (
            <div key={toast.id} className={`toast toast-${toast.type}`}>
              <div className="toast-content">{toast.message}</div>
              <button className="toast-close" onClick={() => removeToast(toast.id)}>×</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default ApiPollingAlert;